// extracted by mini-css-extract-plugin
export default {"marker":"AzK0V6","pin":"YbY03z"};